import {
  getTaxCertificationRequestAsync,
  postCancelTaxCertificationAsync,
  postCreateTaxCertificationRequestAsync,
} from 'API/order/title/adminTaxCertificationAPI';
import { createAsyncSlice } from 'store/createAsyncSlice';
import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import { ITaxCertificationRequestData } from '../../../types/order/title/ITaxCertificationRequest';

export const { slice: taxCertificationRequestsSlice, asyncAction: getTaxCertificationRequestAsyncAction } =
  createAsyncSliceWithDataAndQuery(
    'taxCertificationRequestsSlice',
    getTaxCertificationRequestAsync,
    {} as ITaxCertificationRequestData
  );

export const { slice: createTaxCertificationRequestSlice, asyncAction: postCreateTaxCertificationRequestAsyncAction } =
  createAsyncSlice('createTaxCertificationRequestSlice', postCreateTaxCertificationRequestAsync);

export const { slice: cancelTaxCertificationSlice, asyncAction: postCancelTaxCertificationAsyncAction } =
  createAsyncSlice('cancelTaxCertificationSlice', postCancelTaxCertificationAsync);
